import React, { useState, useRef } from "react";
import "../assets/css/navbar.css";
import logo from '../assets/images/logo.png'
import appImage from '../assets/images/app.png'
 
function Navbar() {
  const [menu, setMenu] = useState(false);
  const ref = useRef(null);
  const ref2 = useRef(null);

  const changeMenu = () => {
    const el2 = ref.current;
    const el = ref2.current;

    el2.classList.toggle("change");
    if (menu) {
      el.style.bottom = "100%";
      setMenu(false);
    } else {
      el.style.bottom = "0";
      setMenu(true);
    }
  };

  return (
    <nav className="Navbar sticky-top d-flex justify-content-between">
      <div className="navbar__left">
        <a href='/'><img src={logo} className="logo pt-1" style={{height:'120px' , width:'80px'}} alt="" /></a>
        
                
      </div>
      <div className="navbar__right">
        <ul className="navbar__rightOptions ">        
          <li className="navbar__home">
          
          {/* <i className="bi bi-google-play pt-4"/> */}
          <a
                    className="d-flex"
                    target="_blank"
                    rel="noreferrer"
                    href=" https://play.google.com/store/apps/details?id=com.SKBK"
                  >
          <img src={appImage} height="80" width="60" className="pt-2 mx-4"  alt="" />
          <p className="applink pt-4">  RKSMBK App यहाँ डाउनलोड करें</p></a>
          
          </li>
          
        </ul>
        <div ref={ref} onClick={changeMenu} className="navbar__hamburger">
          <div className="bar1"></div>
          <div className="bar2"></div>
          <div className="bar3"></div>
        </div>

        <div ref={ref2} className="navbar__hamburgerMenu">
          <ul className="navbar__hamburgerIconsOptions">
            <li className="navbar__home">
              <a href="#About">HOME</a>
            </li>
            <li className="navbar__about">
              <a href="#Home">ABOUT</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
